import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTextFieldDefaultProps } from '../../utils/TextFieldUtils';

import SnackbarUtils from 'utils/SnackbarUtils';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import {
  selectAllInputValue,
  setCursorToStartPosition,
} from '../../utils/InputMaskUtils';
import styles from './CustomTextField.scss';
const rootClassName = styles.rootClassName;

class CustomTextField extends Component {
  lastTime = new Date().getTime();
  inputBuffer = [];
  currInterval = null;

  constructor(props) {
    super(props);
    this.state = {
      maxSize: this.props.maxSize,
      value: this.props.value || '',
      pristine: true,
    };

    this.getCounter = this.getCounter.bind(this);
    this.onFocus = this.onFocus.bind(this);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (this.props.value !== newProps.value) {
      this.setValue(newProps.value || '');
    }
  }

  UNSAFE_componentWillMount() {
    this.setValue(this.props.value || '');
  }

  getCounter() {
    if (this.props.counter) {
      if (this.props.maxSize) {
        return this.props.maxSize - this.state.value.length;
      } else {
        throw new Error(
          'Quando a prop "counter" é "true", você deve passar um valor para a prop "maxSize".'
        );
      }
    }
    return 0;
  }

  setValue(value) {
    this.setState({
      ...this.state,
      value: value,
    });
  }

  getClasses() {
    return getMergedClassNames([rootClassName, this.props.className || '']);
  }

  getHelperText() {
    const hasHelperText =
      this.props.helperText && this.props.helperText.length > 0 ? true : false;
    const hasCounter = this.props.counter && this.props.maxSize ? true : false;
    if (this.allowShowError() && (hasHelperText || hasCounter)) {
      return (
        <span className={rootClassName + '-helper-text-container'}>
          {hasHelperText ? (
            <span className={rootClassName + '-helper-text'}>
              {this.props.helperText}
            </span>
          ) : (
            ''
          )}
          {hasCounter ? (
            <span className={rootClassName + '-helper-text-counter'}>
              {this.props.counter && this.props.maxSize
                ? this.getCounter() + '/' + this.props.maxSize
                : ''}
            </span>
          ) : (
            ''
          )}
        </span>
      );
    }
    return <span className={rootClassName + '-helper-text-container'}></span>;
  }

  onInput(event) {
    if (new Date().getTime() < this.lastTime + 500) {
      this.inputBuffer.push(event);
    }
    this.lastTime = new Date().getTime();
    if (this.currInterval) {
      window.clearInterval(this.currInterval);
      this.currInterval = null;
    }
    this.currInterval = window.setInterval(() => {
      window.clearInterval(this.currInterval);
      this.currInterval = null;
      if (this.props.onInput) {
        this.props.onInput(
          this.inputBuffer.length > 0
            ? this.inputBuffer[this.inputBuffer.length - 1]
            : event
        );
      }
    }, 500);
  }

  onFocus(event) {
    if (this.props.isAutoComplete) {
      event.target.setAttribute('autocomplete', 'disabled');
    }
    setTimeout(() => {
      if (event.target.value.length === 0) {
        event.target.setSelectionRange(0, 0);
      } else {
        event.target.select();
      }
    }, 0);
    if (typeof this.props.onFocus === 'function') {
      this.props.onFocus(event);
    }
  }

  getLimitAlertMessage = (limit) => {
    if (
      typeof this.props.limitAlertMessage === 'string' &&
      this.props.limitAlertMessage.trim().length > 0
    ) {
      return this.props.limitAlertMessage;
    }
    const message =
      this.props.type && this.props.type === 'tel'
        ? this.props.languageValues.customNumberFieldIsLonger
        : this.props.languageValues.customTextFieldIsLonger;
    /* eslint-disable-next-line */
    return message.split('${1}').join(limit);
  };

  allowShowError = () => {
    return this.props.validateAfterBlur && this.state.pristine ? false : true;
  };

  render() {
    let allProps = {
      color: 'secondary',
      ...getTextFieldDefaultProps(),
      ...this.props,
      disabled: this.props.multiline ? undefined : this.props.disabled,
      InputProps: {
        ...(this.props.InputProps || {}),
        disabled: this.props.multiline ? undefined : this.props.disabled,
        'aria-readonly':
          this.props.readonly || (this.props.multiline && this.props.disabled),
        readOnly:
          this.props.readonly || (this.props.multiline && this.props.disabled),
      },
      className: this.getClasses(),
      onFocus: this.onFocus,
      onClick: (event) => {
        if (this.props.isAutoComplete) {
          selectAllInputValue(event);
        } else {
          if (this.props.InputProps && this.props.InputProps.inputComponent) {
            setCursorToStartPosition(event);
          }
        }
        if (typeof this.props.onClick === 'function') {
          this.props.onClick(event);
        }
      },
      onBlur: (e) => {
        const newEvent = { ...e };
        new Promise((resolve) => {
          if (this.state.pristine) {
            this.setState(
              {
                pristine: false,
              },
              () => {
                resolve();
              }
            );
          } else {
            resolve();
          }
        }).then(() => {
          if (typeof this.props.onBlur === 'function') {
            this.props.onBlur(newEvent);
          }
        });
      },
      onChange: (e) => {
        if (this.props.maxSize && e.target.value.length > this.props.maxSize) {
          SnackbarUtils.enqueueSnackbar({
            message: this.getLimitAlertMessage(this.props.maxSize),
            options: {
              autoHideDuration: 6000,
              variant: 'warning',
            },
          });
          e.target.value = e.target.value.substr(0, this.props.maxSize);
        }
        if (typeof this.props.onChange === 'function') {
          this.props.onChange(e);
        }
      },
      helperText: this.getHelperText(),
      FormHelperTextProps: {
        ...this.props.formHelperTextProps,
        className:
          this.props.formHelperTextProps + ' ' + rootClassName + '-counter',
      },
    };
    if (!this.allowShowError()) {
      allProps.error = false;
    }
    delete allProps.validateAfterBlur;
    delete allProps.languageValues;
    delete allProps.enqueueSnackbar;
    delete allProps.maxSize;
    delete allProps.counter;
    delete allProps.isAutoComplete;
    delete allProps.limitAlertMessage;
    return <TextField {...allProps} />;
  }
}

CustomTextField.propTypes = {
  ...TextField.propTypes,
  validateAfterBlur: PropTypes.bool,
  maxSize: PropTypes.number,
  counter: PropTypes.bool,
  isAutoComplete: PropTypes.bool,
  limitAlertMessage: PropTypes.string,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CustomTextField);